
import XHeader from 'vux/src/components/x-header/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import CellBox from 'vux/src/components/cell-box/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'


export default {
  components: {
    XHeader,
    Group,
    Cell,
    CellBox,
    Flexbox,
    FlexboxItem
  },
  data () {
    return {
      pageTitle: '通知公告',
      noticeData: {},
      userName: false,
      pageType: ''
    }
  },
  mounted () {
    if (this.$store.state.userInfo.accounts) {
      this.userName = this.$store.state.userInfo.accounts
    }

    this.axios({
      url: this.$store.state.url + '/wechat/information/list',
      method: 'get'
    }).then((response) => {
      this.noticeData = response.data
    }).catch((response) => {
    })
},
  methods: {
    goLogin () {
      this.$router.push({ name: 'Login'})
    }
  }
}



// WEBPACK FOOTER //
// ./src/page/Notice.vue